import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from '@/components/ui/toast';
import { useToast } from '@/components/ui/use-toast';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, descriptionClassName, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription className={descriptionClassName}>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
